import lottie from 'lottie-web'
import gsap from 'gsap'

export default class ActionButton {

	constructor( element, parent ) {

		this.buttonElement = element
		this.parent = parent
		this.staticIcon = this.buttonElement.querySelector( ".main_icon" )
		this.loadingAnimationContainer = this.buttonElement.querySelector( ".loading_animation" )
		this.loadingAnimation = lottie.loadAnimation( {
			container: this.loadingAnimationContainer,
			renderer: "svg",
			loop: true,
			autoplay: true,
			path: "/animations/loading_animation.json"
		} )

		this.loaded = false

	}

	triggerLoadComplete() {

		this.buttonElement.classList.remove( "loading" )
		const timeline = gsap.timeline()
		timeline.to( this.loadingAnimationContainer, { opacity: 0 } )
		timeline.to( this.staticIcon, { opacity: 1, scale: 1 }, "-=0.35" )
		this.loaded = false
		return timeline

	}

	triggerLoad() {

		this.buttonElement.classList.add( "loading" )
		const timeline = gsap.timeline()
		timeline.to( this.staticIcon, { opacity: 0, scale: 0, ease: "power2.inOut" } )
		timeline.to( this.loadingAnimationContainer, { opacity: 1, ease: "expo.inOut" }, "<" )
		this.loaded = true
		return timeline

	}

}
